import withLazyLoad from 'bv-lazy-load';

const sectionComponentsLazyLoad = withLazyLoad();

export const GamesListComponent = sectionComponentsLazyLoad('gamesList');
export const LiveCasinoGamesListComponent = sectionComponentsLazyLoad('liveCasinoGamesList');
export const WidgetComponent = sectionComponentsLazyLoad('widget');
